import ChangeLogin from './ChangeLogin';

export default ChangeLogin;
